<script lang="ts">
	import Checkbox from '../../../components/Checkbox/Checkbox.svelte';
	import NewButton from '../../../components/NewButton/NewButton.svelte';
	import { Translations } from '../types';
	import { attachInformationStore, loadAllStore, isSelectAllBtnDisabledStore } from '../stores/stores';
	export let translations: Translations;
	export let toggleTextArea: () => void;

	let toggleAttachInformation = true;

	function selectAll() {
		isSelectAllBtnDisabledStore.set(true);
		loadAllStore.set(true);
	}

	$: {
		attachInformationStore.set(toggleAttachInformation);
	}
</script>


<div class="footer-recipient">
	<div>
		<Checkbox bind:checked={toggleAttachInformation} label={translations.attachInformation} />
		<Checkbox on:click={toggleTextArea} label={translations.freeTextEmail}/>
	</div>
	
	<NewButton type={"secondary"} text={translations.takeAll} on:click={selectAll} disabled={$isSelectAllBtnDisabledStore}/>
</div>
